module.exports = __webpack_public_path__ + "media/2.c42fb247.mp4";